import Flickity from 'flickity';
import fade from 'flickity-fade';


(function ($) {
    var slider = new Flickity('.flickity-slider',{
        contain: true,
        wrapAround: true,
        fade:true,
        autoPlay: 5000,
        pauseAutoPlayOnHover: false,
        adaptiveHeight: true,
        pageDots: true,
        prevNextButtons: false
    })

})(jQuery);